import { useEffect, useState } from 'react';
import { useGetBranches } from './logic/use-get-branches';
import Center from '../../components/center';
import Spinner from '../../components/spinner';
import TableReservationCreateForm from './component/table-reservation-create-form';
import TableReservationCreateBranchError from './component/table-reservation-create-branch-error';
import { useSearchParams } from 'react-router-dom';
import { useCompany } from '@app/page/menu-preview/use-menu-query.ts';
import { useTolgee } from '@tolgee/react';
import { getInitialLanguage, setAutoLanguage } from '../../utils/language-detection';

const TableReservationCreate = () => {
  const [params] = useSearchParams();
  const companyID = params.get('companyID');
  const { data } = useCompany(companyID);
  const tolgee = useTolgee(['language']);
  const branchID = params.get('branchID');

  // Smart language detection with priority system
  useEffect(() => {
    if (!data?.storefront_company.settings.customerDefaultLanguage) {
      return;
    }

    const initialLanguage = getInitialLanguage(data.storefront_company.settings.customerDefaultLanguage);
    setAutoLanguage(initialLanguage, tolgee.changeLanguage);
  }, [data?.storefront_company.settings.customerDefaultLanguage, tolgee.changeLanguage]);

  const { data: branchesData, loading } = useGetBranches(companyID);
  const [selectedBranch, setSelectedBranch] = useState<string>('');

  const selectedBranchData = branchesData?.storefront_tableReservationBranches.find(
    (branch) => branch.id === selectedBranch
  );

  useEffect(() => {
    setSelectedBranch(branchID ?? '');
  }, [branchID]);

  useEffect(() => {
    if (selectedBranchData) {
      document.title = `Reservation at ${selectedBranchData.name}`;
    } else {
      document.title = 'Reservation';
    }
  }, [selectedBranchData]);

  const alternateBookingUrl = selectedBranchData?.company.hubPage?.alternateBookingUrl;

  // Check for alternate booking URL and redirect if available
  useEffect(() => {
    if (alternateBookingUrl) {
      window.location.href = alternateBookingUrl;
    }
  }, [alternateBookingUrl]);

  if (companyID === null) {
    return <div>Company ID is required</div>;
  }

  if (!branchID) {
    return <div>BranchID is require</div>;
  }

  if (loading) {
    return (
      <Center>
        <Spinner />
      </Center>
    );
  }

  if (!selectedBranchData) {
    return (
      <div>
        <TableReservationCreateBranchError />
      </div>
    );
  }

  // Keep the form hidden while the browser navigates to the alternate booking URL
  if (alternateBookingUrl) {
    return (
      <Center>
        <Spinner />
      </Center>
    );
  }

  return (
    <>
      <TableReservationCreateForm selectedBranch={selectedBranchData} branchID={branchID} companyID={companyID} />
    </>
  );
};

export default TableReservationCreate;
